import { states } from "../constants/States";
import { Selectinput } from "./Inputs";

export default function StatesSelect({formData, handleInputChange}: {formData: any, handleInputChange: any }) {
    const stateOptions = [
        { value: '', label: 'Select state' },
        ...states
    ];

    return (
        <Selectinput
            label="State"
            name="state"
            value={formData.state}
            onChange={handleInputChange}
            options={stateOptions}
        />
    )
}

